export default __webpack_public_path__ + "static/media/house1.df526362.jpg";